import React from 'react';
export function FinalCTA() {
  return <section className="bg-rise-black text-rise-white py-20 md:py-[140px] px-6 text-center relative overflow-hidden" data-id="element-93">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-b from-transparent to-rise-gold/30" data-id="element-94"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-px h-24 bg-gradient-to-t from-transparent to-rise-gold/30" data-id="element-95"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-96">
        <h2 className="font-playfair text-[40px] md:text-[48px] mb-6" data-id="element-97">
          Ești gata să ieși din blocaj?
        </h2>
        <p className="font-dm-sans text-[19px] text-rise-white/70 mb-10" data-id="element-98">
          Intră în Programul sau în comunitatea R.I.S.E.
        </p>

        <div className="flex flex-col items-center sm:flex-row justify-center gap-4 w-full sm:w-auto" data-id="element-99">
          <a href="https://wa.me/40771296017" target="_blank" rel="noopener noreferrer" className="bg-rise-gold text-rise-black hover:bg-rise-gold-light px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center w-full sm:w-auto" data-id="element-100">
            Înscrie-mă în Program
          </a>
          <a href="https://wa.me/40771296017" target="_blank" rel="noopener noreferrer" className="border border-rise-gold text-rise-gold hover:bg-rise-gold/10 px-8 py-4 rounded-xl font-dm-sans font-semibold text-[15px] transition-colors flex items-center justify-center w-full sm:w-auto" data-id="element-101">
            Vreau doar acces la Comunitate
          </a>
        </div>
      </div>
    </section>;
}